import "./Button.scss";
import rightArrow from "../../assets/icons/rightArrow.svg";

const Button = ({ type, label, action }) => {
  return (
    <button
      className={`button button__${type}`}
      onClick={action}
      type={`${type === "rewrite" || type === "switch" ? "button" : "submit"}`}
    >
      <span className="button__label">{label}</span>
      {type === "switch" ? (
        <img
          src={rightArrow}
          className="button__switch-img"
          alt="right arrow"
        />
      ) : null}
    </button>
  );
};

export default Button;
